import React, { useState, useEffect, useContext } from "react";
import { useParams } from 'react-router-dom';
import { Row, Col, Button, Tour, Popconfirm } from 'antd';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../App';
import { API } from "../components/Initilization";
import { useNotificationContext } from '../components/NotificationContext'
import "../assets/css/designer.css"

// react-pintura
import { PinturaEditor } from "@pqina/react-pintura";

import TShirtBlackBack from '../assets/images/Designer/TshirtBackDesignBlack.png';
import TShirtWhiteBack from '../assets/images/Designer/TshirtBackDesign.png';
import TShirtGreyBack from '../assets/images/Designer/TshirtBackGrayDesign.png';
import KidShirtBlackBack from '../assets/images/Designer/KidDorsBackBlack.png';
import KidShirtWhiteBack from '../assets/images/Designer/KidDorsBackWhite.png';
import KidShirtGreyBack from '../assets/images/Designer/KidDorsBackGrey.png';
import WomenTShirtBlackBack from '../assets/images/Designer/WomenTShirtBlackBackDesign.png';
import WomenTShirtWhiteBack from '../assets/images/Designer/WomenTshirtBackDesign.png';
import WomenTShirtGreyBack from '../assets/images/Designer/WomenTShirtGreyBackDesign.png';
import CropTShirtBlackBack from '../assets/images/Designer/CropTshirtBackBlack.png';
import CropTShirtWhiteBack from '../assets/images/Designer/CropTshirtBackWhite.png';
import CropTShirtGreyBack from '../assets/images/Designer/CropTshirtBackGrey.png';
import ShirtBlackBack from '../assets/images/Designer/MenDorsBackBlack.png';
import ShirtWhiteBack from '../assets/images/Designer/MenDorsBackWhite.png';
import ShirtGreyBack from '../assets/images/Designer/MenDorsBackGrey.png';
import HoodieBlackBack from '../assets/images/Designer/MenHoodieBlaackBack.png';
import HoodieWhiteBack from '../assets/images/Designer/MenHoodieWhiteBack.png';
import HoodieGreyBack from '../assets/images/Designer/MenHoodieGreyBack.png';
import CollarTShirtBlackBack from '../assets/images/Designer/CollarTshirtBlackBack.png';
import CollarTShirtWhiteBack from '../assets/images/Designer/CollarTshirtBackWhite.png';
import CollarTShirtGreyBack from '../assets/images/Designer/CollarTShirtBackGrey.png';
import WomenCollarTShirtBlackBack from '../assets/images/Designer/WomenCollarBackBlack.png';
import WomenCollarTShirtWhiteBack from '../assets/images/Designer/WomanCollarBackWhite.png';
import WomenCollarTShirtGreyBack from '../assets/images/Designer/WomenCollarBackGrey.png';


// pintura
import "@pqina/pintura/pintura.css";
import {
  getEditorDefaults,
  setPlugins,
  plugin_sticker,
  plugin_sticker_locale_en_gb,
  createMarkupEditorShapeStyleControls,
} from "@pqina/pintura";

setPlugins(plugin_sticker);

export default function SecondDesigner() {
  const notif = useNotificationContext();
  const { firstDesignBase64, firstDesignAdditionalPics } = useContext(MyContext);
  const navigate = useNavigate();
  const { ProductType } = useParams(); // Gets the dynamic ID from the URL  

  // Inline result
  const [designBackGround, setDesignBackGround] = useState(null);
  const [nextDesignURL, setNextDesignURL] = useState(true);
  const [nextStepPopUp, setNextStepPopUp] = useState(false);
  const [result, setResult] = useState("");
  const [uploadedImages, setUploadedImages] = useState([])
  const [designedImageBase64, setDesignedImageBase64] = useState('');

  const [open, setOpen] = useState(true);
  const steps = [
    {
      title: 'طراحی پشت محصول',
      description: 'در صورت نیاز پشت لباس خود را نیز میتوانید طراحی کنید',
      target: null,
      nextButtonProps: {
        children: (
          <>متوجه شدم</>
        ),

      }
    }
  ];

  useEffect(() => {
    switch (ProductType.split("-")[0]) {

      // MEN 
      case "MenTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(TShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(TShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(TShirtGreyBack)
            break;
        }
        break;

      case "MenCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CollarTShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(CollarTShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(CollarTShirtGreyBack)
            break;
        }
        break;

      case "MenShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(ShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(ShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(ShirtGreyBack)
            break;
        }
        break;

      case "MenHoodie":

        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhiteBack)
            break;
          case "Black":
            setDesignBackGround(HoodieBlackBack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGreyBack)
            break;
        }
        break;


      // WOMEN

      case "WomenTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(WomenTShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(WomenTShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(WomenTShirtGreyBack)
            break;
        }
        break;

      case "WomenCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(WomenCollarTShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(WomenCollarTShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(WomenCollarTShirtGreyBack)
            break;
        }
        break;

      case "WomenShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(ShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(ShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(ShirtGreyBack)
            break;
        }
        break;

      case "WomenHoodie":

        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhiteBack)
            break;
          case "Black":
            setDesignBackGround(HoodieBlackBack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGreyBack)
            break;
        }
        break;

      case "WomenCropTShirt":

        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CropTShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(CropTShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(CropTShirtGreyBack)
            break;
        }
        break;


      // BOYS 
      case "BoysTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(TShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(TShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(TShirtGreyBack)
            break;
        }
        break;

      case "BoysCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CollarTShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(CollarTShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(CollarTShirtGreyBack)
            break;
        }
        break;

      case "BoysShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(KidShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(KidShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(KidShirtGreyBack)
            break;
        }
        break;

      case "BoysHoodie":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhiteBack)
            break;
          case "Black":
            setDesignBackGround(HoodieBlackBack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGreyBack)
            break;
        }
        break;



      // BOYS 
      case "GirlsTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(TShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(TShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(TShirtGreyBack)
            break;
        }
        break;

      case "GirlsCollarTShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(CollarTShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(CollarTShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(CollarTShirtGreyBack)
            break;
        }
        break;

      case "GirlsShirt":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(KidShirtWhiteBack)
            break;
          case "Black":
            setDesignBackGround(KidShirtBlackBack)
            break;
          case "Grey":
            setDesignBackGround(KidShirtGreyBack)
            break;
        }
        break;

      case "GirlsHoodie":


        switch (ProductType.split("-")[1]) {
          case "White":
            setDesignBackGround(HoodieWhiteBack)
            break;
          case "Black":
            setDesignBackGround(HoodieBlackBack)
            break;
          case "Grey":
            setDesignBackGround(HoodieGreyBack)
            break;
        }
        break;


    }

    setInterval(
      () => {
        const spans = document.querySelectorAll("span");

        // Loop through and modify only those with "Sticker"
        spans.forEach((span) => {
          if (span.innerHTML == "Select image") {
            span.innerText = "انتخاب عکس"
          }
          if (span.innerHTML == "Font color") {
            span.innerText = "رنگ فونت"
          }
          if (span.innerHTML == "Font") {
            span.innerText = "فونت"
          }
          if (span.innerHTML == "Font style") {
            span.innerText = "استایل فونت"
          }
          if (span.innerHTML == "Font style") {
            span.innerText = "استایل فونت"
          }
          if (span.innerHTML == "Font size") {
            span.innerText = "اندازه فونت"
          }
          if (span.innerHTML == "Line height") {
            span.innerText = "اندازه سطر"
          }
          switch (span.innerHTML.trim()) {
            case "Sticker":
              span.innerText = "افزودن عکس";
              break;
            case "Annotate":
              span.innerText = "افزودن متن"
              break;
            case "font color":
              span.innerText = "افزودن متن"
              break;
          }
        });
      },
      100
    );

  }, []);

  const handleCaptureAndNextStep = () => {
    setNextStepPopUp(false)
    debugger
    document.getElementById("NextStepPopConfirm").style.display = "none"
    document.getElementsByTagName("nav")[0].style.display = "none"
    document.getElementById("commendation").style.display = "none"
    document.getElementById("pinturaNavButtons").style.display = "none"
    document.getElementsByTagName("footer")[0].style.display = "none"

    window.print();

    document.getElementsByTagName("nav")[0].style.display = "block"
    document.getElementById("commendation").style.display = "block"
    document.getElementById("pinturaNavButtons").style.display = "block"
    document.getElementsByTagName("footer")[0].style.display = "block"

    document.getElementsByClassName("PinturaButtonExport")[0].click()


  };

  const NextStep = () => {
    document.getElementsByClassName("PinturaButtonExport")[0].click()
  };

  const editorDefaults = getEditorDefaults({
    util: "sticker",
    utils: ["sticker", "annotate"],
    locale: {
      ...plugin_sticker_locale_en_gb,
    },

  });

  const handleEditorAddshape = async (shape) => {
    try {
      let base64Image;

      if (shape.backgroundImage && shape.backgroundImage.startsWith("blob:")) {
        const response = await fetch(shape.backgroundImage);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          base64Image = reader.result;
          saveImage(base64Image, shape.id);
        };
      }
      else if (shape.backgroundImage) {
        base64Image = await convertUrlToBase64(shape.backgroundImage);
        saveImage(base64Image, shape.id);
      }

    } catch (error) {
      alert("Error handling shape image");
    }
  };

  const saveImage = (base64, id) => {
    const prevUploadedImages = [...uploadedImages];
    prevUploadedImages.push({
      id: id,
      ImageBase64: base64,
    });
    setUploadedImages(prevUploadedImages);
  };

  const convertUrlToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result); // Base64 result
          };
          reader.onerror = reject; // Reject on error
          reader.readAsDataURL(blob); // Convert Blob to Base64
        })
        .catch(reject); // Handle fetch errors
    });
  };

  const handleEditorRemoveshape = (shape) => {
    var newUploadedImages = uploadedImages.filter(item => item.id !== shape.id);
    setUploadedImages(newUploadedImages)
  };

  const ReturnBtnConfirm = (e) => {
    navigate("/choose-product");

  };

  const GetProductPrice = async (slug) => {  
    try {  
      var s = slug.split("-")
      const response = await API.get('/api/product/get-product-price', {  
        params: { slug: s[0] + "-" + s[1] + "-" + s[2] },  
      });  
      if (response.status === 200 && response.data.ResultCode === 200) {  
        return parseInt(response.data.Obj);  
      }  
    } catch (error) {  
      console.error(error);  
      return null;  
    }  
  };

  const handlePurchase = async (backimagebase64) => {
    console.log("data:")
    console.log("firstDesignBase64")
    console.log(firstDesignBase64)
    console.log("firstDesignAdditionalPics")
    console.log(firstDesignAdditionalPics)
    console.log("designedImageBase64")
    console.log(designedImageBase64)
    console.log("uploadedImages")
    console.log(uploadedImages)


    var AdditionalDesignImage = []
    var totalUploadedImages = firstDesignAdditionalPics.concat(uploadedImages);
    debugger
    totalUploadedImages.forEach((item) => {
      AdditionalDesignImage.push({DesignPicture: item.ImageBase64})
    })
    const unitPrice = await GetProductPrice(ProductType);
    var DesignedOrders = [
      {
        Key: Date.now() % 10000000,
        ProductName: ProductType.split("-")[0],
        ProductColor: ProductType.split("-")[1],
        ProductQuality: ProductType.split("-")[2],
        ProductSize: ProductType.split("-")[3],
        FirstDesignPic: firstDesignBase64,
        SecondDesignPic: backimagebase64,
        Amount: 1,
        UnitPrice: unitPrice,
        AdditionalDesignImage: JSON.stringify(AdditionalDesignImage)

      },
    ]

    var storedOrders = JSON.parse(localStorage.getItem('designedOrders'));
    if (storedOrders == null){
      storedOrders = []
    }

    storedOrders.push(DesignedOrders[0])

    const ordersToStore = JSON.stringify(storedOrders);  

    localStorage.setItem('designedOrders', ordersToStore); 
    window.dispatchEvent(new Event('cartUpdated'));
 

    notif.open({
      type: 'success',
      style: { width: "450px" },
      className: "fYekan-bold",
      placement: 'topRight',
      message: 'موفق',
      description: 'طراحی شما به سبد خرید افزوده شد',
    });
    setTimeout(() => {  
      navigate("/cart");
  }, 1500); 

    

    // var bodyFormData = new FormData();

    // bodyFormData.append("MobileNumber", "values.FullName")
    // bodyFormData.append("DeliveryAddress", "values.MobileNumber")
    // bodyFormData.append("PostalCode", "values.Email")
    // bodyFormData.append("Description", "values.Text")
    // bodyFormData.append("DesignedOrders", JSON.stringify(DesignedOrders))
    // API.post('/api/order/create-purchase', bodyFormData, { NeedsAuthorization: true })
    //   .then((response) => {
    //     debugger;
    //     if (response.status == 200 && response.data.ResultCode == 200) {

          
    //       setTimeout(function () {
    //         window.location.href = "/"
    //       }, 2000)

    //     }
    //   })
    //   .catch((error) => {
    //   });
  };

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto" }}>

      {/* <Tour open={open} onClose={() => setOpen(false)} steps={steps} /> */}
      <Row align={"center"} >
        <Col id="pinturaNavButtons" style={{ backgroundColor: "white", maxWidth: "1000px", borderRadius: "16px 16px 0 0" }} span={21} >
          <Row className="pb-4">
            <Col span={12}>
              <Popconfirm
                id="ReturnPopConfirm"
                placement="bottom"
                title="هشدار!"
                description="در صورت بازگشت تغییرات اعمال شده ذخیره نخواهد شد"
                onConfirm={ReturnBtnConfirm}
                okText="بازگشت"
                cancelText="لغو"
                zIndex={29}
                okButtonProps={{ style: { width: '160px' } }}   
                cancelButtonProps={{ style: { width: '160px' } }}  

              >
                <Button type="secondary" className="button-100-2">برگشت</Button>
              </Popconfirm>

            </Col>
            <Col span={12}>
              <Popconfirm
                id="NextStepPopConfirm"
                placement="bottom"
                title="تایید"
                description={<p>طراحی دلخواه شما با موفقیت ذخیره گردید.<br /> در صورتی که می خواهید این طراحی را به صورت پی در اف در دستگاه <br /> خود ذخیره کنید، دکمه ی ذخیره PDF و  مرحله ی بعد را انتخاب کنید</p>}
                onConfirm={NextStep}
                onCancel={handleCaptureAndNextStep}
                cancelText="ذخیره PDF و افزودن به سبد "
                okText="ذخیره و افزودن به سبد"
                okButtonProps={{ style: { width: '160px' } }}   
                cancelButtonProps={{ style: { width: '160px' } }}  
                zIndex={29}
              >
                <Button type="primary" className="button-100-1">تایید و مرحله ی  بعد</Button>
              </Popconfirm>
            </Col>
          </Row>
        </Col>
        <Col id="PintureEditorCanvas" span={21} style={{ height: "850px", maxWidth: "1000px" }}>

          <PinturaEditor
            enableButtonRevert={false}
            {...editorDefaults}

            markupEditorShapeStyleControls={createMarkupEditorShapeStyleControls(
              {
                annotateActiveTool: 'text',
                fontSizeOptions: [10, 20, 30, 45, 60, 75, 95, 105, 130, 155, 185, 215, 250, 290, 350, 450, 600, 850],
                lineHeightOptions: false,
              }
            )}
            onAddshape={handleEditorAddshape}
            onRemoveshape={handleEditorRemoveshape}
            markupEditorToolbar={["text"]}
            annotateActiveTool="text"
            stickers={[
              [
                'بچگانه',

                [
                  "/assets/DesignerPage/Cute/CL1236-14.png",
                  "/assets/DesignerPage/Cute/CL1236-17.png",
                  "/assets/DesignerPage/Cute/CL1237-17.png",
                  "/assets/DesignerPage/Cute/CL1237-19.png",
                  "/assets/DesignerPage/Cute/CL1237-22.png",
                  "/assets/DesignerPage/Cute/CL1241-06.png",
                  "/assets/DesignerPage/Cute/CL1242-10.png",
                  "/assets/DesignerPage/Cute/CL1244-06.png",
                  "/assets/DesignerPage/Cute/CL1244-12.png",
                  "/assets/DesignerPage/Cute/CL1244-14.png",
                  "/assets/DesignerPage/Cute/HAPPY-EASTER-01.png",
                  "/assets/DesignerPage/Cute/HAPPY-EASTER-18.png",

                ],

              ],
              [
                'خرگوش',
                [
                  "/assets/DesignerPage/Rabbit/CL1237-02.png",
                  "/assets/DesignerPage/Rabbit/CL1237-05.png",
                  "/assets/DesignerPage/Rabbit/CL1237-10.png",
                  "/assets/DesignerPage/Rabbit/CL1239-03.png",
                  "/assets/DesignerPage/Rabbit/CL1239-04.png",
                  "/assets/DesignerPage/Rabbit/CL1239-05.png",
                  "/assets/DesignerPage/Rabbit/CL1240-03.png",
                  "/assets/DesignerPage/Rabbit/CL1240-05.png",
                  "/assets/DesignerPage/Rabbit/CL1241-01.png",
                  "/assets/DesignerPage/Rabbit/CL1241-03.png",
                  "/assets/DesignerPage/Rabbit/CL1242-01.png",
                  "/assets/DesignerPage/Rabbit/CL1244-01.png",
                  "/assets/DesignerPage/Rabbit/HAPPY-EASTER-10.png",
                  "/assets/DesignerPage/Rabbit/Untitled-6-04.png",
                ],
              ],
              [
                'جوجه',
                [
                  "/assets/DesignerPage/Chicken/CL1242-03.png",
                  "/assets/DesignerPage/Chicken/CL1244-03.png",
                  "/assets/DesignerPage/Chicken/EASTER-06.png",
                  "/assets/DesignerPage/Chicken/HAPPY-EASTER-14.png",
                ],
                // group properties
                {

                },
              ],
            ]}
            src={designBackGround}
            imageCropAspectRatio={1}
            enableTapToAddText={true}
            onLoad={(res) => {

              console.log("load image", res)
            }}

            onProcess={({ dest }) => {
              const reader = new FileReader();
              reader.readAsDataURL(dest);
              reader.onloadend = () => {
                const base64data = reader.result;
                setDesignedImageBase64(base64data)
                handlePurchase(base64data)
                if (nextDesignURL) {
                  navigate("/second-designer/" + ProductType);
                }
                else {
                  // navigate("/second-designer/" + ProductType);
                }
              };
            }}
          />

        </Col>
      </Row>
    </div>

  );
}


